import { ScoreGauge } from "./ScoreGauge";

export const ProvinceGaugeList = ({ provinces, selected, onSelect }) => (
  <ul className="divide-y divide-slate-100" data-testid="province-gauge-list">
    {provinces.map((p) => (
      <li key={p.code}>
        <button
          onClick={() => onSelect(selected === p.code ? null : p.code)}
          data-testid={`province-gauge-${p.code}`}
          aria-pressed={selected === p.code}
          className={`grid w-full grid-cols-[2.5rem_1fr_2.5rem] items-center gap-3 rounded-xl px-3 py-3 text-left transition-colors sm:grid-cols-[9rem_1fr_3rem] ${selected === p.code ? "bg-sky-50" : "hover:bg-slate-50"}`}
        >
          <span className="text-sm font-medium text-slate-800">
            <span className="sm:hidden">{p.code}</span>
            <span className="hidden sm:inline">{p.name}</span>
          </span>
          <ScoreGauge score={p.score} />
          <span className="text-right font-mono text-sm text-slate-700" data-testid={`province-score-${p.code}`}>{Math.round(p.score)}</span>
        </button>
      </li>
    ))}
  </ul>
);
